import {EpLayer} from "./layer";
import {boundariesStyle} from "../styles/boundaries";
import * as turf from "@turf/turf";
import buffer from "@turf/buffer";
import {toLonLat} from "ol/proj";

export class EpBoundariesLayer extends EpLayer {
    _bufferedPolygons = {}

    constructor(map) {
        super(map);

        this.style = boundariesStyle;
        this.title = 'Granice obwodu';
        this.name = 'boundaries'

        return this;
    }

    getBufferedBoundariesPolygon(bufferSize = 2) {
        if(typeof this._bufferedPolygons[bufferSize] != 'undefined') {
            return this._bufferedPolygons[bufferSize];
        }

        let coordinates = [];
        for (let coords of this.getSource().getFeatures()[0].getGeometry().getCoordinates()[0]) {
            coordinates = [...coordinates, toLonLat(coords)]
        }

        this._bufferedPolygons[bufferSize] = turf
            .toMercator(
                buffer(
                    {
                        type: "Feature",
                        properties: {},
                        geometry: {
                            type: "Polygon",
                            coordinates: [coordinates]
                        }
                    },
                    bufferSize,
                    'metres'
                )
            );

        return this._bufferedPolygons[bufferSize];
    }
}
